import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../auth/login.service';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';

declare var google: any;
declare var FB: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  person!: FormGroup;
  contentReady = false;
  loggedIn = false;
  isMobile = false;
  isAr = false;
  private isBrowser: boolean;
  isPasswordVisible: boolean = false;
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  constructor(
    private _FormBuilder: FormBuilder,
    private _LoginService: LoginService,
    private _Router: Router,
    private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.initiate();

    if (!this.isBrowser) return;

    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';

    if (localStorage.getItem('token')) {
      this.loggedIn = true;
      this._Router.navigate(['/Home']);
    }

    this.initSocialSDKs();
  }

  private initiate(): void {
    this.person = this._FormBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  private initSocialSDKs(): void {
    // هنا بس تحط Google / Facebook init لو محتاج
    // مثال:
    // if (google) { ... }
    // if (FB) { ... }
  }

  private decodeToken(token: string): any {
    if (!this.isBrowser) return null;
    return JSON.parse(atob(token.split('.')[1]));
  }

  onSubmit(): void {
    this.contentReady = true;

    this._LoginService.user_login(this.person.value).subscribe({
      next: (res) => {
        this.contentReady = false;

        if (this.isBrowser) {
          localStorage.setItem('username', res.user.username);
        }

        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'اهلا بيك في زازو' : 'Welcome to Zazu',
          confirmButtonText: this.isAr ? 'حسناً' : 'OK',
          showConfirmButton: false,
          timer: 1500,
        });

        this._LoginService.setToken(res.token);
        this._Router.navigate(['/Home']);
      },

      error: () => {
        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr
            ? 'البيانات اللي مدخلها فيها حاجة غلط'
            : 'Wrong Username or Password',
          text: this.isAr ? 'كلم الدعم' : 'You have to contact us',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      },
    });
  }
}
